import { Controller } from 'react-hook-form';
import Select from 'react-select';

const ReactSelectField = ({ label, name, control, required, errors, options = [], isDisabled }) => {
  return (
    <div className="form-group" style={{ height: "95px" }} id="new_select_id">
      <label htmlFor={name} className="form-label label_class_name_for_input">
        {label} {required && <span style={{ color: "#FF3939" }}>*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? `${label} is required` : false,
        }}
        render={({ field }) => (
          <Select
            {...field}
            options={options}
            isDisabled={isDisabled}
            classNamePrefix="react-select"
            placeholder={`Select ${label}`}
          />
        )}
      />
      {errors[name] && (
        <p className="input_error">{errors[name].message}</p>
      )}
    </div>
  );
};

export default ReactSelectField;
